import moment from "moment";

export const dateToIso = (createdAt) => {
    if (!createdAt) return moment().format('YYYY-MM-DD');

    try {
        // If the date is already in ISO-like format (from SQL Server), use moment
        if (createdAt.includes('-') || createdAt.includes('T')) {
            const m = moment(createdAt);
            return m.isValid() ? m.format('YYYY-MM-DD') : '-';
        }

        const m = moment(createdAt, 'DD/MM/YYYY');
        return m.isValid() ? m.format('YYYY-MM-DD') : '-';
    } catch (e) {
        return '-';
    }
}

export const retrieveCustomDate = (
    requestStatus,
    updatedAt,
    createdAt,
    createdRecordAt,
) => {
    const emptyDate = '-'

    // If all dates are null or undefined, return emptyDate
    if (!updatedAt && !createdAt && !createdRecordAt) {
        return emptyDate;
    }

    // Checks if createdAt is null or undefined and createdRecordAt is not null
    // If so, it returns the createdRecordAt date formatted as 'YYYY-MM-DD'
    if (createdRecordAt && !createdAt) {
        return moment(createdRecordAt).format('YYYY-MM-DD');
    }

    // Otherwise, it returns the createdAt date formatted as 'YYYY-MM-DD'
    return dateToIso(createdAt);
}

export const validateDate = (date) => {
    if (!date) return false;
    const m = moment(date, moment.ISO_8601, true);
    return m.isValid();
}
